// components/Common/SaveStatus.jsx
import React from "react";
import "./SaveStatus.css";

const LABELS = {
  pending: "Unsaved changes…",
  saving: "Saving…",
  saved: "All changes saved",
  error: "Saving failed – changes will be retried on the next edit",
  blocked: "Not saved – fix the problem below",
};

/** Small autosave indicator. Renders nothing while status is "idle". */
const SaveStatus = ({ status, className = "" }) => {
  if (!status || status === "idle") return null;

  return (
    <span className={`save-status save-status--${status} ${className}`} role="status" aria-live="polite">
      <span className="save-status__dot" aria-hidden="true" />
      {LABELS[status]}
    </span>
  );
};

export default SaveStatus;
